// src/pages/CarPricesPage.tsx - REFACTORED
import { useState, useEffect } from 'react';
import { Link } from '../components/Router';
import { Header } from '../components/Header';
import { carPricesApi, CarBrand } from '../lib/carPricesApi';
import { BannerDisplay } from '../components/BannerDisplay';

export function CarPricesPage() {
  const [brands, setBrands] = useState<CarBrand[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadBrands();
  }, []);

  const loadBrands = async () => {
    try {
      const data = await carPricesApi.getBrands();
      setBrands(data);
    } catch (error) {
      console.error('Error loading brands:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Header Section - Clean & Minimal */}
      <div className="bg-white border-b border-gray-200 -mt-16 relative z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <h1 className="text-xl font-semibold text-gray-900 m-0">Prix du Neuf</h1>
          <p className="text-sm text-gray-600 mt-1 font-medium">Découvrez les prix des véhicules neufs en Tunisie</p>
        </div>
      </div>

      {/* Banner wrapper */}
      <div className="w-full">
        <div className="max-w-7xl mx-auto">
          <div className="m-0 p-0">
            <BannerDisplay 
              pageLocation="car-prices" 
              positionKey="top-banner" 
              className="block m-0 p-0"
            />
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {loading ? (
          <div className="flex justify-center items-center py-12">
            <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-[#D5462E]"></div>
          </div>
        ) : brands.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-gray-500 text-sm font-medium">Aucune marque disponible pour le moment.</p>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {brands.map((brand) => (
              <Link
                key={brand.id}
                to={`/neuf/${brand.slug || brand.id}`}
                className="bg-white/80 backdrop-blur-xl rounded-3xl border border-gray-200 hover:border-[#D5462E]/30 transition-all p-6 flex flex-col items-center group"
              >
                <div className="w-16 h-16 mb-4 flex items-center justify-center">
                  {brand.logo_url ? (
                    <img
                      src={brand.logo_url}
                      alt={brand.name}
                      className="max-w-full max-h-full object-contain filter grayscale group-hover:filter-none transition-all"
                     />
                  ) : (
                    <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center border border-gray-200">
                      <span className="text-gray-500 text-xl font-semibold">
                        {brand.name.charAt(0)}
                      </span>
                    </div>
                  )}
                </div>
                <h3 className="text-sm font-medium text-gray-900 group-hover:text-[#D5462E] transition-colors">
                  {brand.name}
                </h3>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}